import { booleanAttribute } from "#ce/utils/props";

const directionOptions = ["row", "column"];

export const props = Object.freeze({
  /**
   * Plain-text legend rendered above the field rows. Override with the legend slot for richer markup.
   *
   * @type {String}
   * @default undefined
   */
  legend: {
    type: String,
    default: undefined,
  },
  /**
   * Forward the flex flag to the inner sp-container so children are laid out via flexbox.
   *
   * @type {Boolean|String}
   * @default false
   */
  flex: booleanAttribute(),
  /**
   * Row gap applied between children by the inner sp-container. Accepts a number (rem) or any CSS length string.
   *
   * @type {Number|String}
   * @default 0.5
   */
  rowgap: {
    type: [Number, String],
    default: 0.5,
  },
  /**
   * Flex direction forwarded to the inner sp-container — "column" stacks children vertically, "row" lays them out horizontally.
   *
   * @type {String}
   * @default "column"
   * @storybook-control select
   */
  direction: {
    type: String,
    default: "column",
    validator: (value) => directionOptions.includes(value),
  },
});
